import { EventProperties } from '../api-client';

type TrackRequest = {
  eventName: string;
  eventProperties?: EventProperties;
  userProperties?: {
    email: string;
  }
};

export const transformTrackRequestData = ({
  eventName,
  eventProperties,
  userProperties,
}: TrackRequest) => {
  const transformedEvent = {
    type: eventName,
    data: eventProperties || {},
    timestamp: Date.now(),
    userEmail: userProperties?.email,
  };
  return JSON.stringify(transformedEvent);
};

/** Local .NET API: ActivityLogsController.Track */
export const transformTrackRequestDataMonolith = ({
  eventName,
  eventProperties,
  userProperties,
}: TrackRequest) => {
  const properties: Record<string, unknown> = { ...(eventProperties || {}) };
  if (userProperties?.email) properties.email = userProperties.email;
  return JSON.stringify({
    event: eventName,
    entityType: null,
    entityId: null,
    properties,
  });
};

type IdentifyRequest = {
  email: string
}

export const transformIdentifyRequestData = ({
  email
}: IdentifyRequest) => {
  const transformedIdentify = {
    userEmail: email
  }
  return JSON.stringify(transformedIdentify);
}
